import React from 'react';
import PropTypes from 'prop-types';
import { initialValues, validationSchema } from './options';
import FormContainer from 'components/Forms';
import { isEmpty } from 'lodash';
import Form from './Form';
import { SCHEDULE_PATTERNS } from 'utils/constants/schedule';
import * as yup from 'yup';
import { v4 } from 'uuid';
import { connect } from 'react-redux';
import { getCountryList, getLanguageList, getTimezone } from 'reducers/utils';
import {
  getSecurityCompanyServices,
  getSitesEnabled,
} from 'reducers/securityCompany';

const MultiSchedule = ({
  closeForm,
  formItem,
  formProps,
  editMode,
  editModeValues,
  timezone,
}) => {
  const onHandleSumbit = values => {
    const schedulePatternValues = formProps.values[formItem.field];
    const { schedule } = values;

    const updateValues = {
      ...values,
      scheduleId: v4(),
      scheduleType: SCHEDULE_PATTERNS[schedule.activeTab].id,
    };

    if (isEmpty(schedulePatternValues)) {
      formProps.setFieldValue(formItem.field, [updateValues]);
    } else {
      formProps.setFieldValue(
        formItem.field,
        schedulePatternValues.concat(updateValues),
      );
    }

    closeForm();
  };

  const onHandleEdit = values => {
    const data = formProps.values[formItem.field];
    const { schedule } = values;

    const updateValues = {
      ...values,
      id: undefined,
      scheduleType: SCHEDULE_PATTERNS[schedule.activeTab].id,
    };

    const index = data.findIndex(i => i.scheduleId === values.scheduleId);

    if (index >= 0) {
      data[index] = updateValues;

      formProps.setFieldValue(formItem.field, data);

      const archived = formProps.values[`deleted${formItem.field}`] || [];
      formProps.setFieldValue(
        `deleted${formItem.field}`,
        archived.concat({
          ...values.originalData,
          archived: true,
        }),
      );
    }

    closeForm();
  };
  return (
    <div>
      <FormContainer
        size="sm"
        title="Schedule"
        requireHeaderSaveBtn
        onClickClose={closeForm}
        onSubmit={editMode ? onHandleEdit : onHandleSumbit}
        buttonText="Submit"
        disablePresist={true}
        initialValues={editMode ? editModeValues : initialValues({ timezone })}
        validationSchema={() =>
          yup.lazy(values => {
            return validationSchema({
              newSite: values.newSite,
              newBusinessClient: values.newBusinessClient,
              newContact: values.newContact,
              activeSchedule: values.schedule.activeTab,
            });
          })
        }
      >
        {props => {
          return (
            <Form formProps={props} taskType={formProps.values.taskType} />
          );
        }}
      </FormContainer>
    </div>
  );
};

MultiSchedule.propTypes = {
  closeForm: PropTypes.func,
  formItem: PropTypes.object,
  formProps: PropTypes.object,
  editMode: PropTypes.bool,
  editModeValues: PropTypes.object,
  subscribedProducts: PropTypes.array,
  countries: PropTypes.array,
  languages: PropTypes.array,
  services: PropTypes.array,
  timezone: PropTypes.string,
  isSiteEnabled: PropTypes.bool,
};

const mapStateToProps = state => ({
  countries: getCountryList(state),
  languages: getLanguageList(state),
  services: getSecurityCompanyServices(state),
  timezone: getTimezone(state),
  isSiteEnabled: getSitesEnabled(state),
});

export default connect(mapStateToProps)(MultiSchedule);
